import { render, staticRenderFns } from "./Operate.vue?vue&type=template&id=50c6d572&scoped=true&"
import script from "./Operate.vue?vue&type=script&lang=js&"
export * from "./Operate.vue?vue&type=script&lang=js&"
import style0 from "./Operate.vue?vue&type=style&index=0&id=50c6d572&lang=scss&scoped=true&"
import style1 from "./Operate.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "50c6d572",
  null
  
)

export default component.exports